import type { DropdownOption } from "@/utilities";

export const DROPDOWN_COUNT_PLACEHOLDER = "{count}";

/** @deprecated Do not use this. Use new Element+ based Select/Autcomplete which do not require this function. */
export interface DropdownSettings {
  nothingSelectedLabel: string;
  somethingSelectedLabel: string;
  noOptionsAvailableLabel: string;
  searchInputPlaceholder: string;
  options: DropdownOption[];
}
